import { Component, OnInit } from "@angular/core";

@Component({
  selector: "millad-privacy-policy",
  templateUrl: "./privacy-policy.component.html",
  styleUrls: ["../policy.scss"],
})
export class PrivacyPolicyComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
